import { ActionsUnion, createAction } from 'app/shared/utils/action-helpers';

// Models
import {
  EventActionTypes,
  EventEditRequest,
} from 'app/shared/eventsOld/models';

export const editEvent = (payload: EventEditRequest) => {
  return createAction(EventActionTypes.EDIT_EVENT, payload);
};

export const editEventSuccess = (payload) => {
  return createAction(EventActionTypes.EDIT_EVENT_SUCCESS, payload);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const EventsActionsList = {
  editEvent,
  editEventSuccess,
};

export type EventsActions = ActionsUnion<typeof EventsActionsList>;
